import { Component, OnInit, HostListener } from "@angular/core";
import { Router } from "@angular/router";
declare var $: any;

import { PerfectScrollbarConfigInterface } from "ngx-perfect-scrollbar";
import { CommonService } from "src/app/views/common/services/common.service";
import { Location } from '@angular/common';


@Component({
  selector: "app-full-layout",
  templateUrl: "./full.component.html",
  styleUrls: ["./full.component.scss"],
})
export class FullComponent implements OnInit {
  public config: PerfectScrollbarConfigInterface = {};

  constructor(private _location: Location,private route: Router,public router: Router, private commonServ: CommonService) {}

  tabStatus = "justified";

  public isCollapsed = false;

  public innerWidth: any;
  public defaultSidebar: any;
  public showSettings = false;
  public showMobileMenu: boolean = false;
  public expandLogo = false;
  public showIcon: boolean = false;

  options = {
    theme: "light", // two possible values: light, dark
    dir: "ltr", // two possible values: ltr, rtl
    layout: "vertical", // fixed value. shouldn't be changed.
    sidebartype: "full", // four possible values: full, iconbar, overlay, mini-sidebar
    sidebarpos: "fixed", // two possible values: fixed, absolute
    headerpos: "fixed", // two possible values: fixed, absolute
    boxed: "full", // two possible values: full, boxed
    navbarbg: "skin6", // six possible values: skin(1/2/3/4/5/6)
    sidebarbg: "skin5", // six possible values: skin(1/2/3/4/5/6)
    logobg: "skin5", // six possible values: skin(1/2/3/4/5/6)
  };

  Logo() {
    this.expandLogo = !this.expandLogo;
  }
  logout() {
    sessionStorage.clear();
    localStorage.clear();
    this.route.navigateByUrl('/authentication/login')
  }
  onBack() {
    this._location.back();
  }
  ngOnInit() {
    // if (this.router.url === '/') {
    //   this.router.navigate(['/dashboard/dashboard1']);
    // }
    // this.toggleSidebarType();
    this.defaultSidebar = this.options.sidebartype;
    this.handleSidebar();
  }

  @HostListener("window:resize", ["$event"])
  onResize(event) {
    this.handleSidebar();
  }


  toggleMobileMenu(): void {
    this.showMobileMenu = !this.showMobileMenu;
    const mobileSidebar = document.getElementById('main-wrapper');
    const mobileIcon = document.getElementById('menu-icon');
    // console.log('ankit',mobileSidebar);
    // console.log('toggle',this.showMobileMenu);
    if (mobileSidebar && mobileIcon) {
      mobileSidebar.classList.toggle('show-sidebar', this.showMobileMenu);
      mobileIcon.classList.toggle('ti-close', this.showMobileMenu); 
      mobileIcon.classList.toggle('ti-menu', !this.showMobileMenu); 
    }
  }


  showSideMenu(event: Event): void {
    event.preventDefault();
    this.toggleMobileMenu(); 
  }

  handleSidebar() {
    this.innerWidth = window.innerWidth;
    switch (this.defaultSidebar) {
      case "full":
      case "iconbar":
        if (this.innerWidth < 1170) {
          this.options.sidebartype = "mini-sidebar";
        } else {
          this.options.sidebartype = this.defaultSidebar;
        }
        break;

      case "overlay":
        if (this.innerWidth < 767) {
          this.options.sidebartype = "mini-sidebar";
        } else {
          this.options.sidebartype = this.defaultSidebar;
        }
        break;

      default:
    }
  }

  toggleSidebarType() {
    switch (this.options.sidebartype) {
      case "full":
      case "iconbar":
        this.options.sidebartype = "mini-sidebar";
        break;

      case "overlay":
        this.toggleMobileMenu(); 
        break;

      case "mini-sidebar":
        if (this.defaultSidebar === "mini-sidebar") {
          this.options.sidebartype = "full";
        } else {
          this.options.sidebartype = this.defaultSidebar;
        }
        break;

      default:
    }
  }
}
